import React from 'react';

export const iconHeaderLogo = (color = '#fff') => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="40"
        height="24"
        viewBox="0 0 40 24"
    >
        <defs>
            <path id="a" d="M0 .057h39.788v23.911H0z" />
            <path id="c" d="M0 .048h34.345v23.91H0z" />
        </defs>
        <g fill="none" fillRule="evenodd">
            <mask id="b" fill={color}>
                <use xlinkHref="#a" />
            </mask>
            <path
                fill="#FFF"
                d="M28.067 23.968a11.557 11.557 0 01-7.964-3.185L15.8 16.86a6.206 6.206 0 01-4.088 1.547c-3.457 0-6.27-2.868-6.27-6.394 0-3.526 2.813-6.395 6.27-6.395a6.19 6.19 0 014.21 1.656l.018.017.102.093.044.043 1.81 1.648a.74.74 0 01.041.035l6.716 6.104a.84.84 0 01.05.049 4.55 4.55 0 003.363 1.476c2.555 0 4.634-2.12 4.634-4.726s-2.079-4.727-4.634-4.727a4.6 4.6 0 00-3.448 1.57l-1.217-1.115a6.225 6.225 0 014.665-2.123c3.457 0 6.27 2.869 6.27 6.395 0 3.526-2.813 6.394-6.27 6.394a6.153 6.153 0 01-4.526-1.97l-6.65-6.044a.836.836 0 01-.042-.037L14.952 8.63a.773.773 0 01-.045-.044l-.03-.028a4.57 4.57 0 00-3.164-1.271c-2.555 0-4.634 2.12-4.634 4.726s2.079 4.726 4.634 4.726a4.601 4.601 0 003.454-1.576.806.806 0 011.154-.066l4.877 4.447.012.01a9.945 9.945 0 006.857 2.746c5.561 0 10.086-4.615 10.086-10.287 0-5.673-4.525-10.287-10.086-10.287-2.864 0-5.604 1.25-7.517 3.43l-1.219-1.113C21.554 1.51 24.738.057 28.067.057c3.131 0 6.074 1.244 8.288 3.502 2.214 2.258 3.433 5.26 3.433 8.454 0 3.193-1.219 6.195-3.433 8.453-2.214 2.258-5.157 3.502-8.288 3.502"
                mask="url(#b)"
            />
            <mask id="d" fill={color}>
                <use xlinkHref="#c" />
            </mask>
            <path
                fill={color}
                d="M11.72 1.716c-5.56 0-10.084 4.615-10.084 10.287 0 5.673 4.524 10.287 10.085 10.287a9.996 9.996 0 006.945-2.83l-2.864-2.603a6.207 6.207 0 01-4.081 1.541c-3.457 0-6.27-2.869-6.27-6.395 0-3.526 2.813-6.394 6.27-6.394 1.726 0 3.332.7 4.526 1.97l6.65 6.044.043.037 1.896 1.726c.016.014.03.03.045.045l.03.028.034.029a4.57 4.57 0 003.13 1.242c2.556 0 4.634-2.12 4.634-4.727 0-2.606-2.078-4.726-4.634-4.726a4.601 4.601 0 00-3.454 1.577.807.807 0 01-1.154.065l-4.865-4.436a9.944 9.944 0 00-6.88-2.766m-.001 22.242c-3.131 0-6.074-1.244-8.288-3.502C1.219 18.2 0 15.197 0 12.003 0 8.81 1.22 5.808 3.433 3.55 5.647 1.292 8.59.048 11.72.048a11.557 11.557 0 017.959 3.18l4.307 3.928a6.207 6.207 0 014.088-1.547c3.457 0 6.27 2.868 6.27 6.394 0 3.526-2.813 6.395-6.27 6.395a6.184 6.184 0 01-4.21-1.656l-.018-.017-.102-.093a.769.769 0 01-.044-.043l-1.81-1.647a.938.938 0 01-.041-.035l-6.716-6.105a.827.827 0 01-.05-.049 4.55 4.55 0 00-3.363-1.476c-2.555 0-4.634 2.12-4.634 4.726 0 2.607 2.079 4.727 4.634 4.727a4.6 4.6 0 003.448-1.57.807.807 0 011.153-.065l4.07 3.7a.845.845 0 01.065 1.179c-2.223 2.532-5.407 3.985-8.736 3.985"
                mask="url(#d)"
            />
        </g>
    </svg>
);

export const iconBrokeChain = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
                fill="#AAA"
                d="M21.33 7.268l-4.14 4.137c-.37.376-1.04.375-1.41.001l-.88-.879 1.8-1.8-1.41-1.414-1.8 1.8-.87-.866a.98.98 0 0 1-.29-.707c0-.269.1-.52.29-.707l4.14-4.139a1.002 1.002 0 0 1 1.41 0l3.16 3.159c.39.391.39 1.025 0 1.415zm-9.5 8.085c.39.391.39 1.025 0 1.415l-4.14 4.137c-.37.376-1.04.375-1.41.001l-3.16-3.159a.98.98 0 0 1-.29-.707c0-.269.1-.52.29-.707l4.14-4.139a1.002 1.002 0 0 1 1.41 0l.87.867-2.25 2.252 1.41 1.414 2.25-2.252.88.878zM22.75 4.439l-3.16-3.158c-1.13-1.131-3.12-1.131-4.24 0l-4.14 4.137a2.964 2.964 0 0 0-.88 2.122c0 .803.31 1.557.88 2.122l.86.865-1.12 1.119-.86-.865c-1.13-1.131-3.12-1.131-4.24 0l-4.14 4.137a2.964 2.964 0 0 0-.88 2.122c0 .803.31 1.557.88 2.122l3.16 3.159a2.96 2.96 0 0 0 2.12.876c.8 0 1.55-.312 2.12-.877l4.14-4.138a3.022 3.022 0 0 0 0-4.243l-.88-.878 1.12-1.12.88.88a2.96 2.96 0 0 0 2.12.876c.8 0 1.55-.312 2.12-.877l4.14-4.138a3.022 3.022 0 0 0 0-4.243zM19 17.021h3v-2h-3zm-3 5h2v-3h-2zm-14-13h3v-2H2zm4-4h2v-3H6z"
            />
        </g>
    </svg>
);

export const iconChainRed = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
                fill="#E52020"
                d="M21.33 7.268l-4.14 4.137c-.37.376-1.04.375-1.41.001l-.88-.879 1.8-1.8-1.41-1.414-1.8 1.8-.87-.866a.98.98 0 0 1-.29-.707c0-.269.1-.52.29-.707l4.14-4.139a1.002 1.002 0 0 1 1.41 0l3.16 3.159c.39.391.39 1.025 0 1.415zm-9.5 8.085c.39.391.39 1.025 0 1.415l-4.14 4.137c-.37.376-1.04.375-1.41.001l-3.16-3.159a.98.98 0 0 1-.29-.707c0-.269.1-.52.29-.707l4.14-4.139a1.002 1.002 0 0 1 1.41 0l.87.867-2.25 2.252 1.41 1.414 2.25-2.252.88.878zM22.75 4.439l-3.16-3.158c-1.13-1.131-3.12-1.131-4.24 0l-4.14 4.137a2.964 2.964 0 0 0-.88 2.122c0 .803.31 1.557.88 2.122l.86.865-1.12 1.119-.86-.865c-1.13-1.131-3.12-1.131-4.24 0l-4.14 4.137a2.964 2.964 0 0 0-.88 2.122c0 .803.31 1.557.88 2.122l3.16 3.159a2.96 2.96 0 0 0 2.12.876c.8 0 1.55-.312 2.12-.877l4.14-4.138a3.022 3.022 0 0 0 0-4.243l-.88-.878 1.12-1.12.88.88a2.96 2.96 0 0 0 2.12.876c.8 0 1.55-.312 2.12-.877l4.14-4.138a3.022 3.022 0 0 0 0-4.243z"
            />
        </g>
    </svg>
);

export const iconChainBlue = (color = '#C31B1C') => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
                fill={color}
                d="M21.33 7.268l-4.14 4.137c-.37.376-1.04.375-1.41.001l-.88-.879 1.8-1.8-1.41-1.414-1.8 1.8-.87-.866a.98.98 0 0 1-.29-.707c0-.269.1-.52.29-.707l4.14-4.139a1.002 1.002 0 0 1 1.41 0l3.16 3.159c.39.391.39 1.025 0 1.415zm-9.5 8.085c.39.391.39 1.025 0 1.415l-4.14 4.137c-.37.376-1.04.375-1.41.001l-3.16-3.159a.98.98 0 0 1-.29-.707c0-.269.1-.52.29-.707l4.14-4.139a1.002 1.002 0 0 1 1.41 0l.87.867-2.25 2.252 1.41 1.414 2.25-2.252.88.878zM22.75 4.439l-3.16-3.158c-1.13-1.131-3.12-1.131-4.24 0l-4.14 4.137a2.964 2.964 0 0 0-.88 2.122c0 .803.31 1.557.88 2.122l.86.865-1.12 1.119-.86-.865c-1.13-1.131-3.12-1.131-4.24 0l-4.14 4.137a2.964 2.964 0 0 0-.88 2.122c0 .803.31 1.557.88 2.122l3.16 3.159a2.96 2.96 0 0 0 2.12.876c.8 0 1.55-.312 2.12-.877l4.14-4.138a3.022 3.022 0 0 0 0-4.243l-.88-.878 1.12-1.12.88.88a2.96 2.96 0 0 0 2.12.876c.8 0 1.55-.312 2.12-.877l4.14-4.138a3.022 3.022 0 0 0 0-4.243z"
            />
        </g>
    </svg>
);

export const iconLink = (color = '#C31B1C') => (
    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path fill={color} d="M11 6V4H2v18h18v-9h-2v7H4V6h7" />
            <path fill={color} d="M22 8.926V2h-7v2h3.586l-7.293 7.292 1.415 1.414L20 5.414v3.512h2" />
        </g>
    </svg>
);

export const iconInfoTooltip = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g fill="none" fillRule="evenodd">
            <path fill="#9299A2" fillOpacity=".01" d="M0 0h20v20H0z" />
            <path
                className="color"
                fill="#37B"
                d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10zM9 15h2v-2H9v2zm0-3h2V5H9v7z"
            />
        </g>
    </svg>
);

export const iconInfoTooltipGrey = (
    <svg height="20" width="20" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h20v20H0z" fill="#9299a2" fillOpacity=".01" />
            <path
                className="color"
                d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10zM9 15h2v-2H9zm0-3h2V5H9z"
                fill="#aaa"
            />
        </g>
    </svg>
);

export const iconPrint = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path fill="#AAA" d="M18 3v7H6V8h5V3h7zm-9 .414V6H6.41L9 3.414zM4 12h16V1H8.59L4 5.586V12z" />
            <path
                fill="#AAA"
                d="M21 19v2H3v-2c-.55 0-1-.448-1-1v-5c0-.551.45-1 1-1h18c.55 0 1 .449 1 1v5c0 .552-.45 1-1 1zM3 10c-1.65 0-3 1.346-3 3v5c0 1.655 1.35 3 3 3h18c1.65 0 3-1.345 3-3v-5c0-1.654-1.35-3-3-3H3z"
            />
            <path fill="#AAA" fillRule="nonzero" d="M6 17v4h12v-4H6zm-2-2h16v8H4v-8z" />
        </g>
    </svg>
);

export const iconDownload = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path className="color" fill="#AAA" fillRule="nonzero" d="M22 22H1v-8h2v6h18v-6h2v8h-1z" />
            <path
                className="color"
                fill="#AAA"
                d="M11 11.694L7.35 8.049 5.94 9.462l6.12 6.116 6.11-6.116-1.41-1.413L13 11.804V.021h-2z"
            />
        </g>
    </svg>
);

export const iconPlay = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" transform="translate(-210 -390)">
            <g fill="#FFF" transform="translate(210 390)">
                <rect width="24" height="24" fill="none" rx="1" />
                <path d="M9 8.33l7.873 4.17L9 16.67z" />
            </g>
            <rect width="46" height="46" x="199" y="379" stroke="#EFF5FA" strokeWidth="2" rx="23" />
        </g>
    </svg>
);

export const iconScrollUp = (arrowColor, bgColor) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
        <g fill="none" fillRule="evenodd">
            <rect width="48" height="48" fill={bgColor || '#FDEDED'} rx="24" />
            <path fill="none" d="M12 12h24v24H12z" />
            <path
                fill={arrowColor || '#37B'}
                d="M25.003 18.479l2.293 2.31 1.419-1.41-4.677-4.709-4.738 4.704 1.411 1.419 2.292-2.277v14.502h2z"
            />
        </g>
    </svg>
);

export const iconBackBtn = (color = '#37B') => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
            <path fill="none" d="M0 24V0h24v24z" />
            <path
                fill={color}
                d="M6.479 10.997l2.31-2.293-1.41-1.419-4.709 4.677L7.374 16.7l1.419-1.411-2.277-2.292h14.502v-2z"
            />
        </g>
    </svg>
);

export const iconSwitchFilters = (
    <svg width="17" height="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 18">
        <g transform="translate(0 1)" fillRule="nonzero" stroke="#333" fill="none">
            <path d="M.8 2H16M.8 8H16M.8 14H16" strokeLinecap="square" />
            <circle fill="#EFF5FA" cx="12.4" cy="2" r="2" />
            <circle fill="#EFF5FA" cx="4.4" cy="8" r="2" />
            <circle fill="#EFF5FA" cx="12.4" cy="14" r="2" />
        </g>
    </svg>
);

export const iconErrorTooltip = (
    <svg height="20" width="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h20v20H0z" fill="#9299a2" fillOpacity=".01" />
            <path
                d="M10 7.879l-1.19-1.19a1.5 1.5 0 1 0-2.12 2.122L7.878 10l-1.19 1.19a1.5 1.5 0 0 0 2.122 2.12L10 12.122l1.19 1.19a1.5 1.5 0 0 0 2.12-2.122L12.122 10l1.19-1.19a1.5 1.5 0 0 0-2.122-2.12zM20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10z"
                fill="#e01f19"
            />
        </g>
    </svg>
);

export const iconSuccessTooltip = (
    <svg height="20" width="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h20v20H0z" fill="#9299a2" fillOpacity=".01" />
            <path
                d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10zM7.134 9.116a1.25 1.25 0 0 0-1.768 1.768l2.5 2.5c.44.44 1.136.49 1.634.116l5-5a1.25 1.25 0 0 0-1.5-2l-4.133 4.35z"
                fill="#39b54a"
            />
        </g>
    </svg>
);

export const iconHelp = (color = '#37B') => (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
                d="M12 22C6.487 22 2 17.515 2 12 2 6.486 6.487 2 12 2c5.514 0 10 4.486 10 10 0 5.515-4.486 10-10 10zm0-22C5.383 0 0 5.384 0 12c0 6.617 5.383 12 12 12 6.618 0 12-5.383 12-12 0-6.616-5.382-12-12-12z"
                fill={color}
            />
            <path
                d="M11 17h1v-5h-1v5zm3-5v-2H8v2h1v7h6v-2h-1v-5zM11.5 6a.5.5 0 11-.002 1.002A.5.5 0 0111.5 6zm0 3C12.879 9 14 7.879 14 6.5 14 5.122 12.879 4 11.5 4A2.503 2.503 0 009 6.5C9 7.879 10.122 9 11.5 9z"
                fill={color}
            />
        </g>
    </svg>
);

export const iconQuestion = (color = '#37B') => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 1C5.92472 1 1 5.92472 1 12C1 18.0753 5.92472 23 12 23C18.0753 23 23 18.0753 23 12C23 5.92472 18.0753 1 12 1ZM3 12C3 7.02928 7.02928 3 12 3C16.9707 3 21 7.02928 21 12C21 16.9707 16.9707 21 12 21C7.02928 21 3 16.9707 3 12ZM10.9068 8.27123C11.314 8.03191 11.7927 7.94443 12.2582 8.02428C12.7238 8.10413 13.146 8.34615 13.4502 8.70749C13.7543 9.06883 13.9208 9.52615 13.9201 9.99847L13.9201 9.99996C13.9201 10.4691 13.555 10.9582 12.8654 11.4179C12.551 11.6275 12.2296 11.7889 11.9827 11.8986C11.8607 11.9529 11.7605 11.9929 11.693 12.0186C11.6594 12.0314 11.6342 12.0406 11.6188 12.046L11.6028 12.0516C11.0796 12.2267 10.7969 12.7926 10.9714 13.3162C11.1461 13.8401 11.7124 14.1233 12.2363 13.9486L12.2376 13.9482L12.2391 13.9477L12.243 13.9464L12.2541 13.9426L12.2888 13.9305C12.3174 13.9203 12.3566 13.906 12.405 13.8876C12.5016 13.8508 12.6358 13.7971 12.795 13.7263C13.1107 13.586 13.5392 13.3724 13.9748 13.082C14.7851 12.5419 15.9197 11.5312 15.9201 10.0009C15.9214 9.05644 15.5884 8.14201 14.9802 7.41949C14.3719 6.69682 13.5274 6.21277 12.5963 6.05307C11.6653 5.89337 10.7078 6.06833 9.89339 6.54696C9.07898 7.02559 8.46025 7.77701 8.14678 8.66812C7.96351 9.18911 8.23728 9.76002 8.75827 9.9433C9.27926 10.1266 9.85018 9.85279 10.0335 9.33181C10.1902 8.88625 10.4996 8.51054 10.9068 8.27123ZM12.0001 16C11.4478 16 11.0001 16.4477 11.0001 17C11.0001 17.5522 11.4478 18 12.0001 18H12.0101C12.5624 18 13.0101 17.5522 13.0101 17C13.0101 16.4477 12.5624 16 12.0101 16H12.0001Z"
            fill={color}
        />
    </svg>
);

export const iconDocument = (color = '#37B') => (
    <svg width="56" height="72" viewBox="0 0 56 72" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_324_263297)">
            <g filter="url(#filter0_d_324_263297)">
                <rect width="56" height="72" rx="1" transform="matrix(1 0 0 -1 0 72)" fill="white" />
            </g>
            <rect x="12" y="16" width="32" height="3" rx="1.5" fill="#EDEDED" />
            <rect x="12" y="23" width="32" height="3" rx="1.5" fill="#EDEDED" />
            <rect x="12" y="30" width="32" height="3" rx="1.5" fill="#EDEDED" />
            <path
                d="M22.6091 59H24.3051V57.304H22.6091V59ZM25.6248 59H28.3128C30.0728 59 30.9368 58.024 30.9368 56.232V50.568C30.9368 48.776 30.0728 47.8 28.3128 47.8H25.6248V59ZM27.3848 57.4V49.4H28.2808C28.8408 49.4 29.1768 49.688 29.1768 50.488V56.312C29.1768 57.112 28.8408 57.4 28.2808 57.4H27.3848ZM34.6688 59.16C36.3968 59.16 37.3408 58.136 37.3408 56.344V50.456C37.3408 48.664 36.3968 47.64 34.6688 47.64C32.9408 47.64 31.9967 48.664 31.9967 50.456V56.344C31.9967 58.136 32.9408 59.16 34.6688 59.16ZM34.6688 57.56C34.1088 57.56 33.7568 57.256 33.7568 56.456V50.344C33.7568 49.544 34.1088 49.24 34.6688 49.24C35.2288 49.24 35.5807 49.544 35.5807 50.344V56.456C35.5807 57.256 35.2288 57.56 34.6688 57.56ZM41.011 59.16C42.707 59.16 43.603 58.136 43.603 56.408V54.824H41.939V56.536C41.939 57.272 41.587 57.56 41.059 57.56C40.531 57.56 40.179 57.272 40.179 56.536V50.28C40.179 49.544 40.531 49.24 41.059 49.24C41.587 49.24 41.939 49.544 41.939 50.28V51.576H43.603V50.392C43.603 48.664 42.707 47.64 41.011 47.64C39.315 47.64 38.419 48.664 38.419 50.392V56.408C38.419 58.136 39.315 59.16 41.011 59.16Z"
                fill="#767D89"
            />
        </g>
        <defs>
            <filter
                id="filter0_d_324_263297"
                x="-24"
                y="-32"
                width="104"
                height="120"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="-8" />
                <feGaussianBlur stdDeviation="12" />
                <feColorMatrix type="matrix" values="0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.16 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_324_263297" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_324_263297" result="shape" />
            </filter>
            <clipPath id="clip0_324_263297">
                <rect width="56" height="72" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const iconProfile = (color = '#37B') => (
    <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <path d="M-1 0h20v20H-1z" />
            <path
                d="M2.333 15.833A4.17 4.17 0 016.5 11.667h5a4.17 4.17 0 014.167 4.166H2.333zm15 0A5.84 5.84 0 0011.5 10h-5a5.84 5.84 0 00-5.833 5.833V17.5h16.666v-1.667zM6.5 5c0-1.378 1.125-2.5 2.5-2.5s2.5 1.122 2.5 2.5c0 1.38-1.125 2.5-2.5 2.5S6.5 6.38 6.5 5zm6.667 0A4.17 4.17 0 009 .833 4.17 4.17 0 004.833 5 4.17 4.17 0 009 9.167 4.17 4.17 0 0013.167 5z"
                fill={color}
            />
        </g>
    </svg>
);

export const iconInfoMob = (color = '#C31B1C') => (
    <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72">
        <g fill={color} fillRule="evenodd">
            <rect width="72" height="72" fillOpacity=".08" rx="36" />
            <path d="M35 47h2V37h-2v10zm6-10v-4H29v4h2v14h12v-4h-2V37zm-5-12a1 1 0 110 2 1 1 0 010-2zm0 6c2.758 0 5-2.242 5-5 0-2.756-2.242-5-5-5-2.756 0-5 2.244-5 5 0 2.758 2.244 5 5 5z" />
        </g>
    </svg>
);

export const iconInfoDesktop = (color = '#C31B1C') => (
    <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h120v120H0z" />
            <rect width="120" height="120" fill="#f3f3f3" rx="60" />
            <path
                fill={color}
                d="M56 80h4V60h-4v20zm12-20v-8H44v8h4v28h24v-8h-4V60zM58 36a2 2 0 11-2 2c0-1.1.9-2 2-2zm0 12c5.516 0 10-4.484 10-10 0-5.512-4.484-10-10-10-5.512 0-10 4.488-10 10 0 5.516 4.488 10 10 10z"
            />
        </g>
    </svg>
);

export const iconPinUp = (color = '#37B') => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
            <path fill="transparent" d="M-104-104h289v230h-289z" />
            <path
                fill={color}
                d="M14.135 5.948l3.917 3.916-6.347 6.35-3.731-4.105 6.161-6.161zM3.209 21.999l5.995-5.995 3.872 4.258 1.265-1.149-1.487-1.635 6.406-6.405 1.531 1.53L22 11.396 12.604 2l-1.208 1.208 1.531 1.531-6.104 6.105L5.8 9.717l-1.265 1.15 3.52 3.871L2 20.791 3.209 22z"
            />
        </g>
    </svg>
);

export const iconPinIn = (color = '#B2CCE5') => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
            <path fill="transparent" d="M-150-104h289v230h-289z" />
            <path
                fill={color}
                d="M3.209 22l5.995-5.996 3.872 4.258 1.265-1.149-1.487-1.635 6.406-6.405 1.531 1.53L22 11.396 12.604 2l-1.208 1.208 1.531 1.531-6.104 6.105L5.8 9.717l-1.265 1.15 3.52 3.871L2 20.791z"
            />
        </g>
    </svg>
);

export const iconSearch = (
    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
        <path
            className="color"
            d="M19.755 18.58l-4.808-4.809A8.431 8.431 0 008.429 0 8.428 8.428 0 000 8.429a8.428 8.428 0 008.429 8.428 8.384 8.384 0 005.338-1.906l4.809 4.804a.833.833 0 001.18-1.175zM8.43 15.18c-3.727 0-6.756-3.029-6.756-6.751A6.763 6.763 0 018.43 1.673c3.722 0 6.755 3.033 6.755 6.756 0 3.722-3.033 6.75-6.755 6.75z"
            fill="#333"
            fillRule="nonzero"
        />
    </svg>
);

export const iconCheck = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13">
        <path
            className="color"
            fill="#333"
            fillRule="evenodd"
            d="M4.421 9.693l-2.733-2.68L0 8.666 4.421 13 16 1.653 14.312 0l-9.89 9.693"
        />
    </svg>
);

export const iconCheckBold = (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
        <path
            fill="#FFF"
            fillRule="evenodd"
            d="M3.24 4.59L1.846 3.283.31 4.713 3.24 7.45l6.174-5.77L7.879.25 3.24 4.59"
        />
    </svg>
);

export const iconArrow = (color = '#37B') => (
    <svg width="10" height="10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10">
        <path
            className="color"
            d="M.006 8.755L1.24 10l4.999-4.948L1.245 0 0 1.233l3.764 3.806L.006 8.755"
            fill={color}
            fillRule="evenodd"
        />
    </svg>
);

export const iconArrowMob = (
    <svg width="8" height="8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 8">
        <path d="M0 .993L3.959 5 8 .998 7.014 0 3.969 3.017.996.005z" fill="#333" fillRule="evenodd" />
    </svg>
);

export const iconCross = (color) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
        <path
            className="color"
            fill={color || '#37B'}
            fillRule="evenodd"
            d="M5 3.585L1.465.05.051 1.464 3.586 5 .051 8.536 1.465 9.95 5 6.414 8.536 9.95 9.95 8.536 6.415 5 9.95 1.464 8.536.05z"
        />
    </svg>
);

export const iconClose = (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
        <g fill="#FFF" fillRule="evenodd">
            <path className="color" d="M1.84.25l15.91 15.91-1.59 1.59L.25 1.84z" />
            <path className="color" d="M16.16.25L.25 16.16l1.59 1.59L17.75 1.84z" />
        </g>
    </svg>
);

export const iconStar = (color = '#909090') => (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 21 21">
        <g fill="none" fillRule="evenodd">
            <path d="M-1-2h24v24H-1z" />
            <path
                className="color"
                fill={color}
                d="M6.155 9.945h3.652l1.129-3.474 1.129 3.474h3.651l-1.779 1.293-1.175.853.448 1.382.68 2.091-1.778-1.292-1.176-.854-2.955 2.146.68-2.091.448-1.382-1.175-.853-1.779-1.293zM4.178 20.8l6.758-4.91 6.757 4.91-2.58-7.945 6.758-4.91h-8.353L10.936 0 8.354 7.945H0l6.758 4.91-2.58 7.945z"
            />
        </g>
    </svg>
);

export const iconStarFilled = (color = '#C31B1C') => (
    <svg width="22" height="22" fill="none" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
        <path
            className="color"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.178 20.8l6.758-4.91 6.757 4.91-2.58-7.945 6.758-4.91h-8.353L10.936 0 8.354 7.945H0l6.758 4.91-2.58 7.945z"
            fill={color}
        />
    </svg>
);

export const iconLogout = (color = '#464A53') => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h20v20H0z" />
            <path
                className="color"
                fill={color}
                d="M14 14h-2v3c0 .55-.448 1-1 1H3c-.551 0-1-.45-1-1V3c0-.55.449-1 1-1h8c.552 0 1 .45 1 1v3h2V3c0-1.65-1.345-3-3-3H3C1.346 0 0 1.35 0 3v14c0 1.65 1.346 3 3 3h8c1.655 0 3-1.35 3-3v-3z"
            />
            <path className="color" fill={color} d="M7 9.09V11h8.04v3.09l4.041-4.04L15.04 6v3.09z" />
        </g>
    </svg>
);

export const iconThumbUp = (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20">
        <g fill="none" fillRule="evenodd">
            <path fill="none" d="M0-.667h20v20H0z" />
            <path
                fill="#909090"
                className="color"
                d="M1.667 10.947a.66.66 0 0 1 .658-.659h1.854a.66.66 0 0 1 .659.659v5.828a.658.658 0 0 1-.659.657H2.325a.659.659 0 0 1-.658-.657v-5.828zm4.837-.375c.294-.199.645-.52.958-1.038.189-.312.549-.846.929-1.409.887-1.32 1.32-1.978 1.461-2.32.281-.683.39-1.53.29-2.267a90.49 90.49 0 0 1-.203-1.676c.09-.017.21-.029.368-.029.435 0 1.498 1.254 1.498 2.896 0 1.587-.195 2.04-.188 2.03a.835.835 0 0 0 .701 1.282h5.16a.708.708 0 0 1 0 1.415h-.83a.833.833 0 1 0 0 1.666h1.159c.39 0 .706.317.706.706a.708.708 0 0 1-.333.595 2.364 2.364 0 0 0-.523-.246.835.835 0 0 0-.251-.04h-1.447a.834.834 0 0 0 0 1.667h1.294a.694.694 0 0 1 .314.31.696.696 0 0 1 .046.54.694.694 0 0 1-.49.47 2.351 2.351 0 0 0-.604-.302.825.825 0 0 0-.25-.039h-1.24a.833.833 0 1 0 0 1.667h1.085a.705.705 0 0 1 .363.85.688.688 0 0 1-.682.493h-7.44a4.246 4.246 0 0 1-1.85-.843v-6.378zM4.18 19.1c.614 0 1.168-.242 1.584-.632 1.183.825 2.378.98 2.437.987.03.004.063.006.094.006h7.497a2.365 2.365 0 0 0 2.308-2.955c.513-.288.918-.76 1.104-1.348.149-.47.145-.961 0-1.421a2.38 2.38 0 0 0 .977-1.908c0-.681-.288-1.296-.75-1.729.267-.384.422-.85.422-1.35a2.377 2.377 0 0 0-2.374-2.375H13.38c.054-.416.092-.953.092-1.645 0-2.345-1.539-4.562-3.165-4.562-1.467 0-1.909.7-2.009.915a.818.818 0 0 0-.073.445s.177 1.592.266 2.237c.059.443-.011.996-.18 1.406-.105.244-.826 1.315-1.303 2.024-.397.59-.773 1.148-.971 1.477-.149.244-.295.39-.404.476-.4-.324-.901-.525-1.454-.525H2.325A2.328 2.328 0 0 0 0 10.947v5.828a2.326 2.326 0 0 0 2.325 2.324h1.854z"
            />
        </g>
    </svg>
);

export const iconSettings = (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
        <path
            fill="#37B"
            fillRule="evenodd"
            d="M5 7.143a2.142 2.142 0 1 1 0-4.286c1.184 0 2.143.957 2.143 2.143S6.183 7.143 5 7.143zm2.977-4.107L9.041 1.97 8.03.957 6.967 2.021A3.513 3.513 0 0 0 5.714 1.5V0H4.286v1.5a3.515 3.515 0 0 0-1.252.521L1.97.957.96 1.971l1.063 1.065c-.248.371-.43.793-.522 1.25H0v1.428h1.5c.094.457.275.879.523 1.25L.959 8.03l1.01 1.014 1.064-1.064c.375.25.798.428 1.253.521V10h1.428V8.5a3.513 3.513 0 0 0 1.253-.521l1.064 1.064 1.01-1.014L7.977 6.97c.249-.378.43-.8.523-1.257H10V4.286H8.5a3.495 3.495 0 0 0-.523-1.25z"
        />
    </svg>
);

export const iconThumbDown = (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20">
        <g fill="none" fillRule="evenodd">
            <path fill="none" d="M0 20.667h20v-20H0z" />
            <path
                fill="#909090"
                className="color"
                d="M1.667 9.053a.66.66 0 0 0 .658.659h1.854a.66.66 0 0 0 .659-.659V3.225a.658.658 0 0 0-.659-.657H2.325a.659.659 0 0 0-.658.657v5.828zm4.837.375c.294.199.645.52.958 1.038.189.312.549.846.929 1.409.887 1.32 1.32 1.978 1.461 2.32.281.683.39 1.53.29 2.267a90.49 90.49 0 0 0-.203 1.676c.09.017.21.029.368.029.435 0 1.498-1.254 1.498-2.896 0-1.587-.195-2.04-.188-2.03a.835.835 0 0 1 .701-1.282h5.16a.708.708 0 0 0 0-1.415h-.83a.833.833 0 1 1 0-1.666h1.159c.39 0 .706-.317.706-.706a.708.708 0 0 0-.333-.595c-.163.1-.335.187-.523.246a.835.835 0 0 1-.251.04h-1.447a.834.834 0 0 1 0-1.667h1.294a.694.694 0 0 0 .314-.31.696.696 0 0 0 .046-.54.694.694 0 0 0-.49-.47 2.351 2.351 0 0 1-.604.302.825.825 0 0 1-.25.039h-1.24a.833.833 0 1 1 0-1.667h1.085a.705.705 0 0 0 .363-.85.688.688 0 0 0-.682-.493h-7.44a4.246 4.246 0 0 0-1.85.843v6.378zM4.18.9c.614 0 1.168.242 1.584.632C6.946.708 8.141.553 8.2.546A.714.714 0 0 1 8.294.54h7.497a2.365 2.365 0 0 1 2.308 2.955c.513.288.918.76 1.104 1.348.149.47.145.961 0 1.421a2.38 2.38 0 0 1 .977 1.908c0 .681-.288 1.296-.75 1.729.267.384.422.85.422 1.35a2.377 2.377 0 0 1-2.374 2.375H13.38c.054.416.092.953.092 1.645 0 2.345-1.539 4.562-3.165 4.562-1.467 0-1.909-.7-2.009-.915a.818.818 0 0 1-.073-.445s.177-1.592.266-2.237c.059-.443-.011-.996-.18-1.406-.105-.244-.826-1.315-1.303-2.024a44.413 44.413 0 0 1-.971-1.477 1.768 1.768 0 0 0-.404-.476c-.4.324-.901.525-1.454.525H2.325A2.328 2.328 0 0 1 0 9.053V3.225A2.326 2.326 0 0 1 2.325.901h1.854z"
            />
        </g>
    </svg>
);

export const iconEye = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="15" viewBox="0 0 24 15">
        <g className="color" fill="#AAA" fillRule="evenodd">
            <path d="M12.005 2.101c3.27 0 6.475 1.796 9.31 5.204-2.835 3.408-6.04 5.202-9.31 5.202-3.28 0-6.485-1.794-9.309-5.202 2.824-3.408 6.03-5.204 9.31-5.204zm0 12.508c4.161 0 8.142-2.304 11.507-6.666L24 7.305l-.488-.637C20.147 2.306 16.166 0 12.005 0 7.834 0 3.853 2.306.5 6.668L0 7.305l.499.637c3.354 4.363 7.335 6.667 11.506 6.667z" />
            <path d="M12.049 5.217c1.148 0 2.087.937 2.087 2.087 0 1.151-.94 2.087-2.087 2.087a2.091 2.091 0 0 1-2.087-2.087c0-1.15.94-2.087 2.087-2.087zm0 6.261a4.175 4.175 0 0 0 4.174-4.174c0-2.3-1.868-4.174-4.174-4.174a4.176 4.176 0 0 0-4.174 4.174 4.175 4.175 0 0 0 4.174 4.174z" />
        </g>
    </svg>
);

export const iconPencil = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 20 24">
        <g fill="#AAA" fillRule="evenodd">
            <path d="M17.09 5.415L16 6.5l-2.59-2.585 1.09-1.086 2.59 2.586zm-13.68 8.5L12 5.329l2.59 2.586L6 16.5l-2.59-2.585zm-1.41 4v-2.586l2.59 2.586H2zm-2 2h5.41l14.5-14.5L14.5 0 0 14.5v5.415zM0 24h20v-2H0z" />
        </g>
    </svg>
);

export const iconUploadFile = (color = '#37B') => (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
        <g fill="none" fillRule="evenodd">
            <path fillRule="nonzero" d="M-1-1h24v24H-1z" />
            <path
                className="color"
                fill={color}
                d="M9.599 0v11.45L7.414 9.27 6 10.68l4.678 4.68 4.677-4.68-1.414-1.41-2.342 2.34V0h-2"
            />
            <path
                className="color"
                fill={color}
                d="M0 10.68c0 5.98 4.866 10.84 10.847 10.84 5.98 0 10.846-4.86 10.846-10.84 0-5.35-3.897-9.8-9-10.68v2.03c3.994.85 7 4.4 7 8.65 0 4.87-3.968 8.84-8.846 8.84S2 15.55 2 10.68c0-4.14 2.854-7.61 6.693-8.57V.05C3.741 1.05 0 5.43 0 10.68"
            />
        </g>
    </svg>
);

export const iconHunburger = (color = '#37B') => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18">
        <g className="color" fill={color} fillRule="evenodd">
            <path d="M0 0h20v2H0zM0 16h20v2H0zM0 8h20v2H0z" />
        </g>
    </svg>
);

export const iconInfoEmpty = (
    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="21" cy="21" r="20" stroke="#3377BB" strokeWidth="2" />
        <path
            d="M17.5474 12.2716C17.3877 10.5148 18.771 9 20.5351 9H21.4649C23.229 9 24.6123 10.5148 24.4526 12.2716L23.4537 23.2592C23.3383 24.5283 22.2743 25.5 21 25.5C19.7257 25.5 18.6617 24.5283 18.5463 23.2592L17.5474 12.2716Z"
            fill="#FFFF75"
        />
        <path
            d="M17.5474 12.2716C17.3877 10.5148 18.771 9 20.5351 9H21.4649C23.229 9 24.6123 10.5148 24.4526 12.2716L23.4537 23.2592C23.3383 24.5283 22.2743 25.5 21 25.5C19.7257 25.5 18.6617 24.5283 18.5463 23.2592L17.5474 12.2716Z"
            fill="#3377BB"
        />
        <rect x="18.75" y="28.5" width="4.5" height="4.5" rx="2.25" fill="#FFFF75" />
        <rect x="18.75" y="28.5" width="4.5" height="4.5" rx="2.25" fill="#3377BB" />
    </svg>
);

export const iconRunning = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 7.23426L16.8725 12.0009L9 16.7676L9 7.23426Z" fill="#3377BB" className="color" />
    </svg>
);

export const iconCheckMarging = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.86223 12.7877L8.02375 11.0448L6 12.9508L9.86223 16.601L18 8.90696L15.9762 7.00098L9.86223 12.7877Z"
            fill="#3377BB"
            className="color"
        />
    </svg>
);

export const iconCloseMarging = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.1819 11.818L6.99985 8.63597L9.12117 6.51465L12.3032 9.69671L15.4853 6.51465L17.6066 8.63597L14.4245 11.818L17.6064 14.9999L15.4851 17.1213L12.3032 13.9393L9.12132 17.1213L7 14.9999L10.1819 11.818Z"
            fill="#3377BB"
            className="color"
        />
    </svg>
);

export const iconClock = (color = '#767D89') => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16ZM8 14.4C11.5346 14.4 14.4 11.5346 14.4 8C14.4 4.46538 11.5346 1.6 8 1.6C4.46538 1.6 1.6 4.46538 1.6 8C1.6 11.5346 4.46538 14.4 8 14.4ZM11.8524 10.5803C12.1365 10.1623 11.9981 9.6119 11.5431 9.35087L8.94247 7.85873V3.89224C8.94247 3.39947 8.50763 3 7.97124 3C7.43484 3 7 3.39947 7 3.89224V8.35344C7 8.66118 7.17262 8.94719 7.45675 9.11021L10.5141 10.8644C10.9691 11.1254 11.5683 10.9982 11.8524 10.5803Z"
            fill={color}
            className="color"
        />
    </svg>
);

export const iconBell = (color = '#FFF') => (
    <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 1.10193C9.23168 1.56377 10.9091 3.54054 10.9091 5.90909V9.75L12 11.5V13H0V11.5L1.09091 9.75V5.90909C1.09091 3.54054 2.76832 1.56377 5 1.10193V1C5 0.447715 5.44772 0 6 0C6.55228 0 7 0.447716 7 1V1.10193ZM8 14C8 15.1046 7.10457 16 6 16C4.89543 16 4 15.1046 4 14H8Z"
            fill={color}
            className="color"
        />
    </svg>
);

export const iconBellDigest = (color = '#464A53') => (
    <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.0097 18H6.00966C6.00966 19.104 6.89966 20 8.00966 20C9.10966 20 10.0097 19.104 10.0097 18ZM0.109661 15.915C0.229661 16.225 0.669661 16.945 2.01966 16.951H14.0097C15.3497 16.951 15.7897 16.229 15.9097 15.918C16.0697 15.529 16.1997 14.738 15.2497 13.815L15.0097 13.579V9C15.0097 5.479 12.3897 2.564 8.99966 2.079V0.979C8.99966 0.438 8.55966 0 8.01966 0C7.47966 0 7.03966 0.438 7.03966 0.979V2.074C3.63966 2.546 1.00966 5.468 1.00966 9V13.588L0.769661 13.814C-0.170339 14.736 -0.0503393 15.526 0.109661 15.915Z"
            fill={color}
        />
    </svg>
);

export const iconComment = (
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 4.586V16V18L13 16H0V0H16V4.586ZM2 11H10V9H2V11ZM14 7H2V5H14V7Z"
            fill="#909090"
            className="color"
        />
    </svg>
);

export const iconArrowSeparator = (color = '#3377BB') => (
    <svg width="14" height="32" viewBox="0 0 14 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.08301 15.999C0.806865 15.999 0.583008 16.2229 0.583008 16.499C0.583008 16.7752 0.806865 16.999 1.08301 16.999V15.999ZM13.4366 16.8526C13.6318 16.6573 13.6318 16.3407 13.4366 16.1455L10.2546 12.9635C10.0593 12.7682 9.74274 12.7682 9.54747 12.9635C9.35221 13.1588 9.35221 13.4753 9.54747 13.6706L12.3759 16.499L9.54747 19.3275C9.35221 19.5227 9.35221 19.8393 9.54747 20.0346C9.74274 20.2298 10.0593 20.2298 10.2546 20.0346L13.4366 16.8526ZM1.08301 16.999H13.083V15.999H1.08301V16.999Z"
            fill={color}
        />
    </svg>
);

export const fileIcons = {
    rtf: (
        <svg width="33" height="13" viewBox="0 0 33 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.43315 12.176C0.953147 12.176 0.595813 12.0587 0.361146 11.824C0.137146 11.5787 0.0251465 11.2694 0.0251465 10.896V10.576C0.0251465 10.2027 0.137146 9.8987 0.361146 9.66403C0.595813 9.4187 0.953147 9.29603 1.43315 9.29603C1.91315 9.29603 2.26515 9.4187 2.48915 9.66403C2.72381 9.8987 2.84115 10.2027 2.84115 10.576V10.896C2.84115 11.2694 2.72381 11.5787 2.48915 11.824C2.26515 12.0587 1.91315 12.176 1.43315 12.176Z"
                fill="#C31B1C"
                className="color"
            />
            <path
                d="M7.57027 12H5.13827V0.832031H10.4343C10.9463 0.832031 11.4103 0.917364 11.8263 1.08803C12.2423 1.2587 12.5943 1.50403 12.8823 1.82403C13.1809 2.13336 13.4103 2.5067 13.5703 2.94403C13.7303 3.38136 13.8103 3.8667 13.8103 4.40003C13.8103 5.15736 13.6396 5.8187 13.2983 6.38403C12.9676 6.94936 12.4609 7.36003 11.7783 7.61603L13.9703 12H11.2663L9.31427 7.90403H7.57027V12ZM10.1303 5.85603C10.4929 5.85603 10.7756 5.76536 10.9783 5.58403C11.1916 5.39203 11.2983 5.1147 11.2983 4.75203V4.04803C11.2983 3.68536 11.1916 3.41336 10.9783 3.23203C10.7756 3.04003 10.4929 2.94403 10.1303 2.94403H7.57027V5.85603H10.1303Z"
                fill="#C31B1C"
                className="color"
            />
            <path d="M20.1849 2.99203V12H17.7529V2.99203H14.7289V0.832031H23.2089V2.99203H20.1849Z" fill="#C31B1C" />
            <path
                d="M24.8726 12V0.832031H32.2806V2.99203H27.3046V5.28003H31.5446V7.42403H27.3046V12H24.8726Z"
                fill="#C31B1C"
                className="color"
            />
        </svg>
    ),
    pdf: (
        <svg width="35" height="13" viewBox="0 0 35 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.51127 12.176C1.03127 12.176 0.673938 12.0587 0.439272 11.824C0.215272 11.5787 0.103271 11.2694 0.103271 10.896V10.576C0.103271 10.2027 0.215272 9.8987 0.439272 9.66403C0.673938 9.4187 1.03127 9.29603 1.51127 9.29603C1.99127 9.29603 2.34327 9.4187 2.56727 9.66403C2.80194 9.8987 2.91927 10.2027 2.91927 10.576V10.896C2.91927 11.2694 2.80194 11.5787 2.56727 11.824C2.34327 12.0587 1.99127 12.176 1.51127 12.176Z"
                fill="#C31B1C"
                className="color"
            />
            <path
                d="M5.2164 12V0.832031H10.4964C11.0191 0.832031 11.4884 0.922698 11.9044 1.10403C12.3204 1.2747 12.6724 1.5147 12.9604 1.82403C13.2591 2.13336 13.4884 2.51203 13.6484 2.96003C13.8084 3.39736 13.8884 3.87736 13.8884 4.40003C13.8884 4.93336 13.8084 5.4187 13.6484 5.85603C13.4884 6.29336 13.2591 6.6667 12.9604 6.97603C12.6724 7.28536 12.3204 7.5307 11.9044 7.71203C11.4884 7.8827 11.0191 7.96803 10.4964 7.96803H7.6484V12H5.2164ZM7.6484 5.85603H10.2084C10.5711 5.85603 10.8537 5.76536 11.0564 5.58403C11.2697 5.39203 11.3764 5.1147 11.3764 4.75203V4.04803C11.3764 3.68536 11.2697 3.41336 11.0564 3.23203C10.8537 3.04003 10.5711 2.94403 10.2084 2.94403H7.6484V5.85603Z"
                fill="#C31B1C"
                className="color"
            />
            <path
                d="M15.7164 0.832031H19.9244C20.6604 0.832031 21.3324 0.949364 21.9404 1.18403C22.5484 1.4187 23.0657 1.7707 23.4924 2.24003C23.9191 2.6987 24.2497 3.28003 24.4844 3.98403C24.7191 4.67736 24.8364 5.48803 24.8364 6.41603C24.8364 7.34403 24.7191 8.16003 24.4844 8.86403C24.2497 9.55737 23.9191 10.1387 23.4924 10.608C23.0657 11.0667 22.5484 11.4134 21.9404 11.648C21.3324 11.8827 20.6604 12 19.9244 12H15.7164V0.832031ZM19.9244 9.84003C20.6497 9.84003 21.2204 9.63737 21.6364 9.23203C22.0524 8.8267 22.2604 8.17603 22.2604 7.28003V5.55203C22.2604 4.65603 22.0524 4.00536 21.6364 3.60003C21.2204 3.1947 20.6497 2.99203 19.9244 2.99203H18.1484V9.84003H19.9244Z"
                fill="#C31B1C"
                className="color"
            />
            <path
                d="M26.8726 12V0.832031H34.2806V2.99203H29.3046V5.28003H33.5446V7.42403H29.3046V12H26.8726Z"
                fill="#C31B1C"
                className="color"
            />
        </svg>
    ),
    xlsx: (
        <svg width="45" height="13" viewBox="0 0 45 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.37065 12.1759C1.89065 12.1759 1.53331 12.0586 1.29865 11.8239C1.07465 11.5786 0.962646 11.2692 0.962646 10.8959V10.5759C0.962646 10.2026 1.07465 9.89856 1.29865 9.66389C1.53331 9.41856 1.89065 9.29589 2.37065 9.29589C2.85065 9.29589 3.20265 9.41856 3.42665 9.66389C3.66131 9.89856 3.77865 10.2026 3.77865 10.5759V10.8959C3.77865 11.2692 3.66131 11.5786 3.42665 11.8239C3.20265 12.0586 2.85065 12.1759 2.37065 12.1759Z"
                fill="#C31B1C"
                className="color"
            />
            <path
                d="M15.512 11.9999H12.696L10.28 7.88789H10.232L7.88002 11.9999H5.25602L8.84002 6.22389L5.43202 0.831893H8.26402L10.44 4.60789H10.488L12.696 0.831893H15.32L11.88 6.27189L15.512 11.9999Z"
                fill="#C31B1C"
                className="color"
            />
            <path
                d="M16.9976 11.9999V0.831893H19.4296V9.83989H23.6856V11.9999H16.9976Z"
                fill="#C31B1C"
                className="color"
            />
            <path
                d="M29.098 12.1919C28.1167 12.1919 27.2847 12.0266 26.602 11.6959C25.9194 11.3546 25.338 10.9172 24.858 10.3839L26.458 8.76789C27.2154 9.62123 28.1487 10.0479 29.258 10.0479C29.8554 10.0479 30.298 9.92523 30.586 9.67989C30.874 9.43456 31.018 9.10923 31.018 8.70389C31.018 8.39456 30.9327 8.13856 30.762 7.93589C30.5914 7.72256 30.2447 7.57856 29.722 7.50389L28.618 7.35989C27.434 7.21056 26.5647 6.85323 26.01 6.28789C25.466 5.72256 25.194 4.97056 25.194 4.03189C25.194 3.53056 25.29 3.07189 25.482 2.65589C25.674 2.23989 25.946 1.88256 26.298 1.58389C26.6607 1.28523 27.098 1.05589 27.61 0.895893C28.1327 0.725226 28.7247 0.639893 29.386 0.639893C30.2287 0.639893 30.97 0.773226 31.61 1.03989C32.25 1.30656 32.7994 1.69589 33.258 2.20789L31.642 3.83989C31.3754 3.53056 31.05 3.27989 30.666 3.08789C30.2927 2.88523 29.818 2.78389 29.242 2.78389C28.698 2.78389 28.2927 2.87989 28.026 3.07189C27.7594 3.26389 27.626 3.53056 27.626 3.87189C27.626 4.25589 27.7274 4.53323 27.93 4.70389C28.1434 4.87456 28.4847 4.99723 28.954 5.07189L30.058 5.24789C31.21 5.42923 32.0634 5.78656 32.618 6.31989C33.1727 6.84256 33.45 7.58923 33.45 8.55989C33.45 9.09323 33.354 9.58389 33.162 10.0319C32.97 10.4799 32.6874 10.8639 32.314 11.1839C31.9514 11.5039 31.498 11.7546 30.954 11.9359C30.41 12.1066 29.7914 12.1919 29.098 12.1919Z"
                fill="#C31B1C"
                className="color"
            />
            <path
                d="M44.7464 11.9999H41.9304L39.5144 7.88789H39.4664L37.1144 11.9999H34.4904L38.0744 6.22389L34.6664 0.831893H37.4984L39.6744 4.60789H39.7224L41.9304 0.831893H44.5544L41.1144 6.27189L44.7464 11.9999Z"
                fill="#C31B1C"
                className="color"
            />
        </svg>
    ),
    doc: (
        <svg width="37" height="13" viewBox="0 0 37 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.5269 12.1759C1.0469 12.1759 0.689563 12.0586 0.454897 11.8239C0.230897 11.5786 0.118896 11.2692 0.118896 10.8959V10.5759C0.118896 10.2026 0.230897 9.89856 0.454897 9.66389C0.689563 9.41856 1.0469 9.29589 1.5269 9.29589C2.0069 9.29589 2.3589 9.41856 2.5829 9.66389C2.81756 9.89856 2.9349 10.2026 2.9349 10.5759V10.8959C2.9349 11.2692 2.81756 11.5786 2.5829 11.8239C2.3589 12.0586 2.0069 12.1759 1.5269 12.1759Z"
                fill="#C31B1C"
                className="color"
            />
            <path
                d="M5.23202 0.831893H9.44002C10.176 0.831893 10.848 0.949226 11.456 1.18389C12.064 1.41856 12.5814 1.77056 13.008 2.23989C13.4347 2.69856 13.7654 3.27989 14 3.98389C14.2347 4.67723 14.352 5.48789 14.352 6.41589C14.352 7.34389 14.2347 8.15989 14 8.86389C13.7654 9.55723 13.4347 10.1386 13.008 10.6079C12.5814 11.0666 12.064 11.4132 11.456 11.6479C10.848 11.8826 10.176 11.9999 9.44002 11.9999H5.23202V0.831893ZM9.44002 9.83989C10.1654 9.83989 10.736 9.63723 11.152 9.23189C11.568 8.82656 11.776 8.17589 11.776 7.27989V5.55189C11.776 4.65589 11.568 4.00523 11.152 3.59989C10.736 3.19456 10.1654 2.99189 9.44002 2.99189H7.66402V9.83989H9.44002Z"
                fill="#C31B1C"
                className="color"
            />
            <path
                d="M20.8683 12.1919C20.1323 12.1919 19.4603 12.0692 18.8523 11.8239C18.2443 11.5786 17.7269 11.2159 17.3003 10.7359C16.8736 10.2452 16.5429 9.64256 16.3083 8.92789C16.0736 8.20256 15.9563 7.36523 15.9563 6.41589C15.9563 5.46656 16.0736 4.63456 16.3083 3.91989C16.5429 3.19456 16.8736 2.59189 17.3003 2.11189C17.7269 1.62123 18.2443 1.25323 18.8523 1.00789C19.4603 0.762559 20.1323 0.639893 20.8683 0.639893C21.6043 0.639893 22.2763 0.762559 22.8843 1.00789C23.4923 1.25323 24.0096 1.62123 24.4363 2.11189C24.8629 2.59189 25.1936 3.19456 25.4283 3.91989C25.6629 4.63456 25.7803 5.46656 25.7803 6.41589C25.7803 7.36523 25.6629 8.20256 25.4283 8.92789C25.1936 9.64256 24.8629 10.2452 24.4363 10.7359C24.0096 11.2159 23.4923 11.5786 22.8843 11.8239C22.2763 12.0692 21.6043 12.1919 20.8683 12.1919ZM20.8683 10.0319C21.6043 10.0319 22.1749 9.79189 22.5803 9.31189C22.9963 8.83189 23.2043 8.14389 23.2043 7.24789V5.58389C23.2043 4.68789 22.9963 3.99989 22.5803 3.51989C22.1749 3.03989 21.6043 2.79989 20.8683 2.79989C20.1323 2.79989 19.5563 3.03989 19.1403 3.51989C18.7349 3.99989 18.5323 4.68789 18.5323 5.58389V7.24789C18.5323 8.14389 18.7349 8.83189 19.1403 9.31189C19.5563 9.79189 20.1323 10.0319 20.8683 10.0319Z"
                fill="#C31B1C"
                className="color"
            />
            <path
                d="M32.3221 12.1919C31.5648 12.1919 30.8821 12.0746 30.2741 11.8399C29.6661 11.5946 29.1488 11.2372 28.7221 10.7679C28.2955 10.2879 27.9648 9.69589 27.7301 8.99189C27.4955 8.27723 27.3781 7.44523 27.3781 6.49589C27.3781 5.55723 27.4955 4.72523 27.7301 3.99989C27.9648 3.26389 28.2955 2.65056 28.7221 2.15989C29.1488 1.65856 29.6661 1.27989 30.2741 1.02389C30.8821 0.767893 31.5648 0.639893 32.3221 0.639893C33.3568 0.639893 34.2101 0.853226 34.8821 1.27989C35.5541 1.69589 36.0928 2.35723 36.4981 3.26389L34.4021 4.35189C34.2528 3.88256 34.0181 3.50923 33.6981 3.23189C33.3888 2.94389 32.9301 2.79989 32.3221 2.79989C31.6075 2.79989 31.0315 3.03456 30.5941 3.50389C30.1675 3.96256 29.9541 4.63456 29.9541 5.51989V7.31189C29.9541 8.19723 30.1675 8.87456 30.5941 9.34389C31.0315 9.80256 31.6075 10.0319 32.3221 10.0319C32.9195 10.0319 33.3941 9.87189 33.7461 9.55189C34.1088 9.22123 34.3755 8.82656 34.5462 8.36789L36.5301 9.51989C36.1141 10.3732 35.5648 11.0346 34.8821 11.5039C34.2101 11.9626 33.3568 12.1919 32.3221 12.1919Z"
                fill="#C31B1C"
                className="color"
            />
        </svg>
    ),
    docx: (
        <svg width="48" height="13" viewBox="0 0 48 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.07377 12.1759C1.59377 12.1759 1.23644 12.0586 1.00177 11.8239C0.777771 11.5786 0.665771 11.2692 0.665771 10.8959V10.5759C0.665771 10.2026 0.777771 9.89856 1.00177 9.66389C1.23644 9.41856 1.59377 9.29589 2.07377 9.29589C2.55377 9.29589 2.90577 9.41856 3.12977 9.66389C3.36444 9.89856 3.48177 10.2026 3.48177 10.5759V10.8959C3.48177 11.2692 3.36444 11.5786 3.12977 11.8239C2.90577 12.0586 2.55377 12.1759 2.07377 12.1759Z"
                fill="#C31B1C"
                className="color"
            />
            <path
                d="M5.7789 0.831893H9.9869C10.7229 0.831893 11.3949 0.949226 12.0029 1.18389C12.6109 1.41856 13.1282 1.77056 13.5549 2.23989C13.9816 2.69856 14.3122 3.27989 14.5469 3.98389C14.7816 4.67723 14.8989 5.48789 14.8989 6.41589C14.8989 7.34389 14.7816 8.15989 14.5469 8.86389C14.3122 9.55723 13.9816 10.1386 13.5549 10.6079C13.1282 11.0666 12.6109 11.4132 12.0029 11.6479C11.3949 11.8826 10.7229 11.9999 9.9869 11.9999H5.7789V0.831893ZM9.9869 9.83989C10.7122 9.83989 11.2829 9.63723 11.6989 9.23189C12.1149 8.82656 12.3229 8.17589 12.3229 7.27989V5.55189C12.3229 4.65589 12.1149 4.00523 11.6989 3.59989C11.2829 3.19456 10.7122 2.99189 9.9869 2.99189H8.2109V9.83989H9.9869Z"
                fill="#C31B1C"
                className="color"
            />
            <path
                d="M21.4151 12.1919C20.6791 12.1919 20.0071 12.0692 19.3991 11.8239C18.7911 11.5786 18.2738 11.2159 17.8471 10.7359C17.4205 10.2452 17.0898 9.64256 16.8551 8.92789C16.6205 8.20256 16.5031 7.36523 16.5031 6.41589C16.5031 5.46656 16.6205 4.63456 16.8551 3.91989C17.0898 3.19456 17.4205 2.59189 17.8471 2.11189C18.2738 1.62123 18.7911 1.25323 19.3991 1.00789C20.0071 0.762559 20.6791 0.639893 21.4151 0.639893C22.1511 0.639893 22.8231 0.762559 23.4311 1.00789C24.0391 1.25323 24.5565 1.62123 24.9831 2.11189C25.4098 2.59189 25.7405 3.19456 25.9751 3.91989C26.2098 4.63456 26.3271 5.46656 26.3271 6.41589C26.3271 7.36523 26.2098 8.20256 25.9751 8.92789C25.7405 9.64256 25.4098 10.2452 24.9831 10.7359C24.5565 11.2159 24.0391 11.5786 23.4311 11.8239C22.8231 12.0692 22.1511 12.1919 21.4151 12.1919ZM21.4151 10.0319C22.1511 10.0319 22.7218 9.79189 23.1271 9.31189C23.5431 8.83189 23.7511 8.14389 23.7511 7.24789V5.58389C23.7511 4.68789 23.5431 3.99989 23.1271 3.51989C22.7218 3.03989 22.1511 2.79989 21.4151 2.79989C20.6791 2.79989 20.1031 3.03989 19.6871 3.51989C19.2818 3.99989 19.0791 4.68789 19.0791 5.58389V7.24789C19.0791 8.14389 19.2818 8.83189 19.6871 9.31189C20.1031 9.79189 20.6791 10.0319 21.4151 10.0319Z"
                fill="#C31B1C"
                className="color"
            />
            <path
                d="M32.869 12.1919C32.1117 12.1919 31.429 12.0746 30.821 11.8399C30.213 11.5946 29.6957 11.2372 29.269 10.7679C28.8424 10.2879 28.5117 9.69589 28.277 8.99189C28.0424 8.27723 27.925 7.44523 27.925 6.49589C27.925 5.55723 28.0424 4.72523 28.277 3.99989C28.5117 3.26389 28.8424 2.65056 29.269 2.15989C29.6957 1.65856 30.213 1.27989 30.821 1.02389C31.429 0.767893 32.1117 0.639893 32.869 0.639893C33.9037 0.639893 34.757 0.853226 35.429 1.27989C36.101 1.69589 36.6397 2.35723 37.045 3.26389L34.949 4.35189C34.7997 3.88256 34.565 3.50923 34.245 3.23189C33.9357 2.94389 33.477 2.79989 32.869 2.79989C32.1544 2.79989 31.5784 3.03456 31.141 3.50389C30.7144 3.96256 30.501 4.63456 30.501 5.51989V7.31189C30.501 8.19723 30.7144 8.87456 31.141 9.34389C31.5784 9.80256 32.1544 10.0319 32.869 10.0319C33.4664 10.0319 33.941 9.87189 34.293 9.55189C34.6557 9.22123 34.9224 8.82656 35.093 8.36789L37.077 9.51989C36.661 10.3732 36.1117 11.0346 35.429 11.5039C34.757 11.9626 33.9037 12.1919 32.869 12.1919Z"
                fill="#C31B1C"
                className="color"
            />
            <path
                d="M47.7464 11.9999H44.9304L42.5144 7.88789H42.4664L40.1144 11.9999H37.4904L41.0744 6.22389L37.6664 0.831893H40.4984L42.6744 4.60789H42.7224L44.9304 0.831893H47.5544L44.1144 6.27189L47.7464 11.9999Z"
                fill="#C31B1C"
                className="color"
            />
        </svg>
    ),
    jpg: (
        <svg width="34" height="13" viewBox="0 0 34 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.5894 12.1759C1.1094 12.1759 0.752063 12.0586 0.517397 11.8239C0.293397 11.5786 0.181396 11.2692 0.181396 10.8959V10.5759C0.181396 10.2026 0.293397 9.89856 0.517397 9.66389C0.752063 9.41856 1.1094 9.29589 1.5894 9.29589C2.0694 9.29589 2.4214 9.41856 2.6454 9.66389C2.88006 9.89856 2.9974 10.2026 2.9974 10.5759V10.8959C2.9974 11.2692 2.88006 11.5786 2.6454 11.8239C2.4214 12.0586 2.0694 12.1759 1.5894 12.1759Z"
                fill="#C31B1C"
                className="color"
            />
            <path
                d="M11.8385 0.831893V8.76789C11.8385 9.27989 11.7532 9.74923 11.5825 10.1759C11.4225 10.5919 11.1825 10.9492 10.8625 11.2479C10.5425 11.5359 10.1532 11.7652 9.69452 11.9359C9.24652 12.0959 8.73452 12.1759 8.15852 12.1759C7.60386 12.1759 7.11319 12.1012 6.68652 11.9519C6.27052 11.8026 5.90786 11.5892 5.59852 11.3119C5.29986 11.0346 5.05452 10.7039 4.86252 10.3199C4.67052 9.93589 4.53719 9.50923 4.46252 9.03989L6.73452 8.59189C6.91585 9.56256 7.37986 10.0479 8.12652 10.0479C8.47852 10.0479 8.77719 9.93589 9.02252 9.71189C9.27852 9.48789 9.40652 9.13589 9.40652 8.65589V2.78389H6.01452V0.831893H11.8385Z"
                fill="#C31B1C"
                className="color"
            />
            <path
                d="M14.232 11.9999V0.831893H19.512C20.0347 0.831893 20.504 0.922559 20.92 1.10389C21.336 1.27456 21.688 1.51456 21.976 1.82389C22.2747 2.13323 22.504 2.51189 22.664 2.95989C22.824 3.39723 22.904 3.87723 22.904 4.39989C22.904 4.93323 22.824 5.41856 22.664 5.85589C22.504 6.29323 22.2747 6.66656 21.976 6.97589C21.688 7.28523 21.336 7.53056 20.92 7.71189C20.504 7.88256 20.0347 7.96789 19.512 7.96789H16.664V11.9999H14.232ZM16.664 5.85589H19.224C19.5867 5.85589 19.8694 5.76523 20.072 5.58389C20.2854 5.39189 20.392 5.11456 20.392 4.75189V4.04789C20.392 3.68523 20.2854 3.41323 20.072 3.23189C19.8694 3.03989 19.5867 2.94389 19.224 2.94389H16.664V5.85589Z"
                fill="#C31B1C"
                className="color"
            />
            <path
                d="M31.82 10.2239H31.74C31.6547 10.7892 31.3667 11.2586 30.876 11.6319C30.3854 12.0052 29.7187 12.1919 28.876 12.1919C28.236 12.1919 27.6387 12.0692 27.084 11.8239C26.5294 11.5786 26.044 11.2159 25.628 10.7359C25.212 10.2559 24.8867 9.65856 24.652 8.94389C24.4174 8.22923 24.3 7.40256 24.3 6.46389C24.3 5.52523 24.4227 4.69323 24.668 3.96789C24.9134 3.24256 25.2547 2.63456 25.692 2.14389C26.14 1.65323 26.6734 1.27989 27.292 1.02389C27.9107 0.767893 28.5987 0.639893 29.356 0.639893C30.3587 0.639893 31.2227 0.858559 31.948 1.29589C32.6734 1.72256 33.244 2.36789 33.66 3.23189L31.676 4.36789C31.5054 3.93056 31.2387 3.56256 30.876 3.26389C30.5134 2.95456 30.0067 2.79989 29.356 2.79989C28.5987 2.79989 27.996 3.01856 27.548 3.45589C27.1 3.89323 26.876 4.58123 26.876 5.51989V7.31189C26.876 8.23989 27.1 8.92789 27.548 9.37589C27.996 9.81323 28.5987 10.0319 29.356 10.0319C29.6547 10.0319 29.9374 9.99989 30.204 9.93589C30.4707 9.86123 30.7054 9.75456 30.908 9.61589C31.1107 9.46656 31.2654 9.29056 31.372 9.08789C31.4894 8.88523 31.548 8.64523 31.548 8.36789V7.80789H29.468V5.77589H33.868V11.9999H31.82V10.2239Z"
                fill="#C31B1C"
                className="color"
            />
        </svg>
    ),
    jpeg: (
        <svg width="44" height="13" viewBox="0 0 44 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.87065 12.1759C1.39065 12.1759 1.03331 12.0586 0.798647 11.8239C0.574647 11.5786 0.462646 11.2692 0.462646 10.8959V10.5759C0.462646 10.2026 0.574647 9.89856 0.798647 9.66389C1.03331 9.41856 1.39065 9.29589 1.87065 9.29589C2.35065 9.29589 2.70265 9.41856 2.92665 9.66389C3.16131 9.89856 3.27865 10.2026 3.27865 10.5759V10.8959C3.27865 11.2692 3.16131 11.5786 2.92665 11.8239C2.70265 12.0586 2.35065 12.1759 1.87065 12.1759Z"
                fill="#C31B1C"
                className="color"
            />
            <path
                d="M12.1198 0.831893V8.76789C12.1198 9.27989 12.0344 9.74923 11.8638 10.1759C11.7038 10.5919 11.4638 10.9492 11.1438 11.2479C10.8238 11.5359 10.4344 11.7652 9.97577 11.9359C9.52777 12.0959 9.01577 12.1759 8.43977 12.1759C7.88511 12.1759 7.39444 12.1012 6.96777 11.9519C6.55177 11.8026 6.18911 11.5892 5.87977 11.3119C5.58111 11.0346 5.33577 10.7039 5.14377 10.3199C4.95177 9.93589 4.81844 9.50923 4.74377 9.03989L7.01577 8.59189C7.1971 9.56256 7.66111 10.0479 8.40777 10.0479C8.75977 10.0479 9.05844 9.93589 9.30377 9.71189C9.55977 9.48789 9.68777 9.13589 9.68777 8.65589V2.78389H6.29577V0.831893H12.1198Z"
                fill="#C31B1C"
                className="color"
            />
            <path
                d="M14.5133 11.9999V0.831893H19.7933C20.3159 0.831893 20.7853 0.922559 21.2013 1.10389C21.6173 1.27456 21.9693 1.51456 22.2573 1.82389C22.5559 2.13323 22.7853 2.51189 22.9453 2.95989C23.1053 3.39723 23.1853 3.87723 23.1853 4.39989C23.1853 4.93323 23.1053 5.41856 22.9453 5.85589C22.7853 6.29323 22.5559 6.66656 22.2573 6.97589C21.9693 7.28523 21.6173 7.53056 21.2013 7.71189C20.7853 7.88256 20.3159 7.96789 19.7933 7.96789H16.9453V11.9999H14.5133ZM16.9453 5.85589H19.5053C19.8679 5.85589 20.1506 5.76523 20.3533 5.58389C20.5666 5.39189 20.6733 5.11456 20.6733 4.75189V4.04789C20.6733 3.68523 20.5666 3.41323 20.3533 3.23189C20.1506 3.03989 19.8679 2.94389 19.5053 2.94389H16.9453V5.85589Z"
                fill="#C31B1C"
                className="color"
            />
            <path
                d="M25.0133 11.9999V0.831893H32.6133V2.99189H27.4453V5.27989H31.8773V7.42389H27.4453V9.83989H32.6133V11.9999H25.0133Z"
                fill="#C31B1C"
                className="color"
            />
            <path
                d="M41.82 10.2239H41.74C41.6547 10.7892 41.3667 11.2586 40.876 11.6319C40.3854 12.0052 39.7187 12.1919 38.876 12.1919C38.236 12.1919 37.6387 12.0692 37.084 11.8239C36.5294 11.5786 36.044 11.2159 35.628 10.7359C35.212 10.2559 34.8867 9.65856 34.652 8.94389C34.4174 8.22923 34.3 7.40256 34.3 6.46389C34.3 5.52523 34.4227 4.69323 34.668 3.96789C34.9134 3.24256 35.2547 2.63456 35.692 2.14389C36.14 1.65323 36.6734 1.27989 37.292 1.02389C37.9107 0.767893 38.5987 0.639893 39.356 0.639893C40.3587 0.639893 41.2227 0.858559 41.948 1.29589C42.6734 1.72256 43.244 2.36789 43.66 3.23189L41.676 4.36789C41.5054 3.93056 41.2387 3.56256 40.876 3.26389C40.5134 2.95456 40.0067 2.79989 39.356 2.79989C38.5987 2.79989 37.996 3.01856 37.548 3.45589C37.1 3.89323 36.876 4.58123 36.876 5.51989V7.31189C36.876 8.23989 37.1 8.92789 37.548 9.37589C37.996 9.81323 38.5987 10.0319 39.356 10.0319C39.6547 10.0319 39.9374 9.99989 40.204 9.93589C40.4707 9.86123 40.7054 9.75456 40.908 9.61589C41.1107 9.46656 41.2654 9.29056 41.372 9.08789C41.4894 8.88523 41.548 8.64523 41.548 8.36789V7.80789H39.468V5.77589H43.868V11.9999H41.82V10.2239Z"
                fill="#C31B1C"
                className="color"
            />
        </svg>
    ),
    xls: (
        <svg width="34" height="13" viewBox="0 0 34 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.13627 12.1759C1.65627 12.1759 1.29894 12.0586 1.06427 11.8239C0.840271 11.5786 0.728271 11.2692 0.728271 10.8959V10.5759C0.728271 10.2026 0.840271 9.89856 1.06427 9.66389C1.29894 9.41856 1.65627 9.29589 2.13627 9.29589C2.61627 9.29589 2.96827 9.41856 3.19227 9.66389C3.42694 9.89856 3.54427 10.2026 3.54427 10.5759V10.8959C3.54427 11.2692 3.42694 11.5786 3.19227 11.8239C2.96827 12.0586 2.61627 12.1759 2.13627 12.1759Z"
                fill="#C31B1C"
                className="color"
            />
            <path
                d="M15.2776 11.9999H12.4616L10.0456 7.88789H9.99765L7.64565 11.9999H5.02165L8.60565 6.22389L5.19765 0.831893H8.02965L10.2056 4.60789H10.2536L12.4616 0.831893H15.0856L11.6456 6.27189L15.2776 11.9999Z"
                fill="#C31B1C"
                className="color"
            />
            <path
                d="M16.7633 11.9999V0.831893H19.1953V9.83989H23.4513V11.9999H16.7633Z"
                fill="#C31B1C"
                className="color"
            />
            <path
                d="M28.8636 12.1919C27.8823 12.1919 27.0503 12.0266 26.3676 11.6959C25.685 11.3546 25.1036 10.9172 24.6236 10.3839L26.2236 8.76789C26.981 9.62123 27.9143 10.0479 29.0236 10.0479C29.621 10.0479 30.0636 9.92523 30.3516 9.67989C30.6396 9.43456 30.7836 9.10923 30.7836 8.70389C30.7836 8.39456 30.6983 8.13856 30.5276 7.93589C30.357 7.72256 30.0103 7.57856 29.4876 7.50389L28.3836 7.35989C27.1996 7.21056 26.3303 6.85323 25.7756 6.28789C25.2316 5.72256 24.9596 4.97056 24.9596 4.03189C24.9596 3.53056 25.0556 3.07189 25.2476 2.65589C25.4396 2.23989 25.7116 1.88256 26.0636 1.58389C26.4263 1.28523 26.8636 1.05589 27.3756 0.895893C27.8983 0.725226 28.4903 0.639893 29.1516 0.639893C29.9943 0.639893 30.7356 0.773226 31.3756 1.03989C32.0156 1.30656 32.565 1.69589 33.0236 2.20789L31.4076 3.83989C31.141 3.53056 30.8156 3.27989 30.4316 3.08789C30.0583 2.88523 29.5836 2.78389 29.0076 2.78389C28.4636 2.78389 28.0583 2.87989 27.7916 3.07189C27.525 3.26389 27.3916 3.53056 27.3916 3.87189C27.3916 4.25589 27.493 4.53323 27.6956 4.70389C27.909 4.87456 28.2503 4.99723 28.7196 5.07189L29.8236 5.24789C30.9756 5.42923 31.829 5.78656 32.3836 6.31989C32.9383 6.84256 33.2156 7.58923 33.2156 8.55989C33.2156 9.09323 33.1197 9.58389 32.9277 10.0319C32.7356 10.4799 32.453 10.8639 32.0796 11.1839C31.717 11.5039 31.2636 11.7546 30.7196 11.9359C30.1756 12.1066 29.557 12.1919 28.8636 12.1919Z"
                fill="#C31B1C"
                className="color"
            />
        </svg>
    ),
};

export const IconCloseTag = ({ size, color }) => {
    if (size === 16) {
        return (
            <span className="icon icon-16">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.70711 3.29289C4.31658 2.90237 3.68342 2.90237 3.29289 3.29289C2.90237 3.68342 2.90237 4.31658 3.29289 4.70711L6.58579 8L3.29289 11.2929C2.90237 11.6834 2.90237 12.3166 3.29289 12.7071C3.68342 13.0976 4.31658 13.0976 4.70711 12.7071L8 9.41421L11.2929 12.7071C11.6834 13.0976 12.3166 13.0976 12.7071 12.7071C13.0976 12.3166 13.0976 11.6834 12.7071 11.2929L9.41421 8L12.7071 4.70711C13.0976 4.31658 13.0976 3.68342 12.7071 3.29289C12.3166 2.90237 11.6834 2.90237 11.2929 3.29289L8 6.58579L4.70711 3.29289Z"
                        fill={color || '#000'}
                        className="icon-color"
                    />
                </svg>
            </span>
        );
    }
    if (size === 24) {
        return (
            <span className="icon icon-24">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6.70708 5.29304C6.51848 5.11088 6.26588 5.01009 6.00368 5.01237C5.74148 5.01465 5.49067 5.11981 5.30526 5.30522C5.11985 5.49063 5.01469 5.74144 5.01241 6.00364C5.01013 6.26584 5.11092 6.51844 5.29308 6.70704L10.5861 12L5.29308 17.293C5.19757 17.3853 5.12139 17.4956 5.06898 17.6176C5.01657 17.7396 4.98898 17.8709 4.98783 18.0036C4.98668 18.1364 5.01198 18.2681 5.06226 18.391C5.11254 18.5139 5.18679 18.6255 5.28069 18.7194C5.37458 18.8133 5.48623 18.8876 5.60913 18.9379C5.73202 18.9881 5.8637 19.0134 5.99648 19.0123C6.12926 19.0111 6.26048 18.9836 6.38249 18.9311C6.50449 18.8787 6.61483 18.8026 6.70708 18.707L12.0001 13.414L17.2931 18.707C17.4817 18.8892 17.7343 18.99 17.9965 18.9877C18.2587 18.9854 18.5095 18.8803 18.6949 18.6949C18.8803 18.5095 18.9855 18.2586 18.9878 17.9964C18.99 17.7342 18.8892 17.4816 18.7071 17.293L13.4141 12L18.7071 6.70704C18.8892 6.51844 18.99 6.26584 18.9878 6.00364C18.9855 5.74144 18.8803 5.49063 18.6949 5.30522C18.5095 5.11981 18.2587 5.01465 17.9965 5.01237C17.7343 5.01009 17.4817 5.11088 17.2931 5.29304L12.0001 10.586L6.70708 5.29304Z"
                        fill={color || '#000'}
                        className="icon-color"
                    />
                </svg>
            </span>
        );
    }
    return null;
};



// WEBPACK FOOTER //
// ./src/utils/svgIcons.js